import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. has_business_hours checks actual business_hours rows
// with is_open = true. hours_customized distinguishes seeded defaults from
// user-authored hours (business_hours_customized_at IS NOT NULL).
export async function resolveHoursItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_business_hours) {
    const reason = progress.hours_customized ? 'hours configured' : 'seeded';
    return { complete: true, reason };
  }
  return { complete: false, reason: 'no hours configured' };
}
